import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnButton from "@shared/components/SnButton";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_SAL_BAS_REG_004 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region Component UseState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>();
  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [gridFocus, setGridFocus] = useState(false);
  //#endregion

  //#region Variables
  const gridref1 = useRef<any>(null);
  const { userInfo } = global();
  let SaveData: any = {};
  const searchRef = useRef<any>(null);
  let btnClick = false;
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setColums(rtn.grid.grid1);
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridref1.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  //#region Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridref1.current.getChange();
    if (modifiedRowsH.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const params = {
        id: "sn_sal_bas_reg_004_01",
        params: searchRef.current.getFormdata(),
      };

      setFocusedRowData(null);
      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));

        setGridFocus(true);
      }

      gridref1.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onInsert = () => {
    try {
      const newRow = {};
      gridref1.current.addRow(newRow);
      setTimeout(() => {
        gridref1.current.api.setFocusedCell(
          gridref1.current.api.getDisplayedRowCount() - 1,
          "cd_cust"
        );
      }, 50);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onBeforeAddRowH = (newRow: RowData): boolean => {
    const searchFormData = searchRef.current.getFormdata();

    const date = searchFormData?.yy?.toString().substring(0, 4) + "00" || "";

    try {
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        fg_trns: searchFormData?.fg_trns,
        ym: date,
        cd_exch: searchFormData?.cd_exch,
        cd_spare: "*",
        am_ar: 0,
        am_col: 0,
        am_cash: 0,
        am_bill: 0,
        am_check: 0,
        am_card: 0,
        am_dc: 0,
        am_fee: 0,
        am_bad: 0,
        am_pl: 0,
        am_ar_isu: 0,
        am_col_a: 0,
        am_col_n: 0,
      };

      Object.assign(newRow, updatedRow); // 원본 객체 수정

      return true;
    } catch (error: any) {
      return false;
    }
  };

  const onDelete = async () => {
    try {
      gridref1.current.deleteSelectedRows();
    } catch (error) {}
  };

  const gridref1btnclick = async (id: string) => {
    if (id == "aButton_App") {
      const searchForm = searchRef.current.getFormdata();

      const searchParam = {
        cd_firm: userInfo.cd_firm,
        yy: searchForm.yy.substring(0, 4) + "00",
        fg_trns: searchForm.fg_trns,
        cd_exch: searchForm.cd_exch,
        tp_cust: searchForm.tp_cust,
      };

      const newParam = {
        id: "sn_sal_bas_reg_004_02",
        params: { ...searchParam },
      };
      const data: any = await fnGetDataSet(newParam);
    }
  };

  const onSave = async () => {
    try {
      gridref1.current.api.stopEditing();
      const requiredValuesCheck = gridref1.current.requiredValuesCheck();
      if (!requiredValuesCheck) {
        return;
      }

      const gridGetChanges = gridref1.current.getChange();
      if (gridGetChanges.modifiedRowcount == 0) {
        await showDialog("error", "변경된 내용이 없습니다.");
        return;
      }

      SaveData["sal_ar"] = gridref1.current.getChange();
      await fnSave("SN_SAL_BAS_REG_004_SAVE_01", SaveData);
      gridref1.current.resetUpdate();

      SaveData = [];
    } catch (error: any) {}
  };
  //#endregion

  //#region Event Method
  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
    },
    [focusedRowData]
  );
  //#endregion

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full w-full">
        <SnGrid
          seq={1}
          ref={gridref1}
          
          enableAddRow={true}
          columnConfig={columns} // 컬럼 설정 전달
          rowData={dataSource1}
          enableExternalChart={false}
          isEditable={true}
          rowSelection="single" // 단일 선택 모드
          onFocusedRowChanged={onFocusedRowChanged}
          onBeforeAddRow={onBeforeAddRowH}
          cellSelection={true}
          title="기초채권정보"
          header={
            <div>
              <SnButton
                text="거래처전개"
                onClick={() => {
                  gridref1btnclick("aButton_App");
                }}
              ></SnButton>
            </div>
          }
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_SAL_BAS_REG_004;
